import { DragAndDrop } from "./DragAndDrop";

class DragAndDropMobile extends DragAndDrop {
  constructor(select, settings = {}) {
    super(select, settings);

    this.initialX = null;
    this.initialY = null;
    this._activeDropArea = null;
  }

  get activeDropArea() {
    return this._activeDropArea;
  }

  set activeDropArea(value) {
    this._activeDropArea = value;
  }

  eventsAvailableCol() {
    const ul = this.renderLocationElement.querySelector(
      ".columns-drag-and-drop-modal__available"
    );

    [...ul.querySelectorAll("li > span")].forEach((item, index) => {
      item.addEventListener("touchstart", this.startAvailableBind);
      item.addEventListener("touchmove", this.overAvailableBind);
      item.addEventListener("touchend", this.endAvailableBind);
      item.addEventListener("touchcancel", this.leaveAvailableBind);
    });
  }

  eventsActiveCol() {
    const ul = this.renderLocationElement.querySelector(
      ".columns-drag-and-drop-modal__active"
    );

    [...ul.querySelectorAll("li > span")].forEach((item, index) => {
      item.addEventListener("touchstart", this.startActiveBind);
      item.addEventListener("touchmove", this.overActiveBind);
      item.addEventListener("touchend", this.endActiveBind);
      item.addEventListener("touchcancel", this.leaveActiveBind);
    });
  }

  // touchstart
  startAvailable(event) {
    event.preventDefault();
    const touches = event.changedTouches;
    const touch = touches.item(0);
    const target = touch.target;

    switch (target.localName) {
      case "span":
        target.classList.add("active");
        target.parentElement.classList.add("active");

        //
        this.initialX = touch.pageX;
        this.initialY = touch.pageY;

        break;

      default:
        break;
    }
  }

  startActive(event) {
    event.preventDefault();
    const touches = event.changedTouches;
    const touch = touches.item(0);
    const target = touch.target;

    switch (target.localName) {
      case "button":
        this.removeOption(target);
        break;

      case "span":
        target.classList.add("active");
        target.parentElement.classList.add("active");

        //
        this.initialX = touch.pageX;
        this.initialY = touch.pageY;

        break;

      default:
        break;
    }
  }

  // touchmove
  overAvailable(event) {
    event.preventDefault();
    const touches = event.changedTouches;
    const touch = touches.item(0);
    const target = touch.target;

    switch (target.localName) {
      case "span":
        let offsetX = touch.pageX - this.initialX;
        let offsetY = touch.pageY - this.initialY;

        // Przesuwanie elementu
        target.style.transform =
          "translateX(" + offsetX + "px) translateY(" + offsetY + "px)";

        //
        this.activeDropArea = document.elementFromPoint(
          touch.pageX,
          touch.pageY
        );

        if (
          this.activeDropArea.closest(".columns-drag-and-drop-modal__active")
        ) {
          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__active")
            .classList.add("active");
        } else if (
          this.activeDropArea.closest(".columns-drag-and-drop-modal__available")
        ) {
          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__available")
            .classList.add("active");

          //
          this.activeDropArea = null;
        } else {
          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__active")
            .classList.remove("active");

          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__available")
            .classList.remove("active");

          //
          this.activeDropArea = null;
        }

        break;

      default:
        break;
    }
  }

  overActive(event) {
    event.preventDefault();
    const touches = event.changedTouches;
    const touch = touches.item(0);
    const target = touch.target;

    switch (target.localName) {
      case "span":
        let offsetX = touch.pageX - this.initialX;
        let offsetY = touch.pageY - this.initialY;

        // Przesuwanie elementu
        target.style.transform =
          "translateX(" + offsetX + "px) translateY(" + offsetY + "px)";

        //
        this.activeDropArea = document.elementFromPoint(
          touch.pageX,
          touch.pageY
        );

        if (
          this.activeDropArea.closest(".columns-drag-and-drop-modal__available")
        ) {
          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__available")
            .classList.add("active");
        } else if (
          this.activeDropArea.closest(".columns-drag-and-drop-modal__active")
        ) {
          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__active")
            .classList.add("active");
        } else {
          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__available")
            .classList.remove("active");

          this.renderLocationElement
            .querySelector(".columns-drag-and-drop-modal__active")
            .classList.remove("active");

          //
          this.activeDropArea = null;
        }

        break;

      default:
        break;
    }
  }

  // touchend
  endAvailable(event) {
    event.preventDefault();
    const touches = event.changedTouches;
    const touch = touches.item(0);
    const dragStartElement = touch.target;
    let dragStartElementRelatedIndex = parseInt(
      dragStartElement.dataset.relatedIndex
    );

    if (this.activeDropArea) {
      const target =
        this.activeDropArea.closest("li") || this.activeDropArea.parentElement;
      const targetIndex = parseInt(target.dataset.index);
      const newDataActive = [...this.dataActive];
      const newDataAvailable = [...this.dataAvailable];

      //
      newDataAvailable[dragStartElementRelatedIndex].selected = true;

      switch (this.activeDropArea.localName) {
        case "ul":
          newDataActive.push(newDataAvailable[dragStartElementRelatedIndex]);
          break;

        case "li":
        case "span":
          newDataActive.splice(
            targetIndex,
            0,
            newDataAvailable[dragStartElementRelatedIndex]
          );
          break;

        default:
          break;
      }

      this.dataAvailable = newDataAvailable;
      this.dataActive = newDataActive;
    } else {
      dragStartElement.removeAttribute("style");
      this.renderLocationElement
        .querySelector(".columns-drag-and-drop-modal__available")
        .classList.remove("active");
    }

    //
    dragStartElement.classList.remove("active");
    dragStartElement.parentElement.classList.remove("active");

    //
    this.activeDropArea = null;
  }

  endActive(event) {
    event.preventDefault();
    const touches = event.changedTouches;
    const touch = touches.item(0);
    const dragStartElement = touch.target;
    let dragStartElementRelatedIndex = parseInt(
      dragStartElement.dataset.relatedIndex
    );
    const dragStartElementParentIndex = parseInt(
      dragStartElement.parentElement.dataset.index
    );

    if (this.activeDropArea) {
      const target =
        this.activeDropArea.closest("li") || dragStartElement.parentElement;
      const targetIndex = parseInt(target.dataset.index);
      const newDataActive = [...this.dataActive];
      const newDataAvailable = [...this.dataAvailable];

      if (
        Boolean(
          this.activeDropArea.closest(".columns-drag-and-drop-modal__available")
        )
      ) {
        //
        newDataAvailable[dragStartElementRelatedIndex].selected = false;

        switch (this.activeDropArea.localName) {
          case "ul":
          case "li":
          case "span":
            newDataActive.splice(dragStartElementParentIndex, 1);

            break;

          default:
            break;
        }
      }

      if (
        Boolean(
          this.activeDropArea.closest(".columns-drag-and-drop-modal__active")
        )
      ) {
        switch (this.activeDropArea.localName) {
          case "ul":
            break;
          case "li":
            if (
              newDataActive.length !== 1 &&
              dragStartElementParentIndex !== targetIndex
            ) {
              newDataActive.push(newDataActive[dragStartElementParentIndex]);
              newDataActive.splice(dragStartElementParentIndex, 1);
            }

            break;
          case "span":
            if (dragStartElementParentIndex < targetIndex) {
              // Przeciąganie góra -> dół.
              newDataActive.splice(
                targetIndex + 1,
                0,
                newDataActive[dragStartElementParentIndex]
              );
              newDataActive.splice(dragStartElementParentIndex, 1);
            }

            if (dragStartElementParentIndex > targetIndex) {
              // Przeciąganie dół -> góra.
              newDataActive.splice(
                targetIndex,
                0,
                newDataActive[dragStartElementParentIndex]
              );
              newDataActive.splice(dragStartElementParentIndex + 1, 1);
            }
            break;

          default:
            break;
        }
      }

      this.dataAvailable = newDataAvailable;
      this.dataActive = newDataActive;
    } else {
      dragStartElement.removeAttribute("style");
      this.renderLocationElement
        .querySelector(".columns-drag-and-drop-modal__active")
        .classList.remove("active");
    }

    //
    dragStartElement.classList.remove("active");
    dragStartElement.parentElement.classList.remove("active");

    //
    this.activeDropArea = null;
  }
}

export { DragAndDropMobile };
